/*
  Noah.Q NEW ITEM product slider v237

  Desktop:
  - 1-4 items: same centered static layout.
  - 5+ items: four cards visible at once with previous/next buttons.
  - Pages advance by four; the final page is clamped so it still shows
    the final four products instead of leaving empty slots.

  Mobile:
  - No slider transform is applied. Existing mobile CSS remains authoritative.
*/
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 990px)';
  var GAP = 22;
  var rafId = 0;

  function uniquePageStarts(count, visible) {
    if (count <= visible) return [0];

    var starts = [];
    var i = 0;

    while (i < count - visible) {
      starts.push(i);
      i += visible;
    }

    starts.push(count - visible);

    return starts.filter(function (value, index, arr) {
      return index === 0 || value !== arr[index - 1];
    });
  }

  function setItemAccess(items, start, visible, enabled) {
    items.forEach(function (item, index) {
      var isVisible = !enabled || (index >= start && index < start + visible);

      if ('inert' in item) {
        item.inert = !isVisible;
      }

      if (isVisible) {
        item.removeAttribute('aria-hidden');
      } else {
        item.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function setupSlider(grid) {
    if (!grid || grid.dataset.noahqSliderReady === 'true') return;

    var drop = grid.closest('.noahq-drop');
    var controls = drop && drop.querySelector('[data-noahq-product-slider-controls]');
    var prev = controls && controls.querySelector('[data-noahq-product-slider-prev]');
    var next = controls && controls.querySelector('[data-noahq-product-slider-next]');

    if (!drop || !controls || !prev || !next) return;

    var items = Array.prototype.slice.call(grid.children).filter(function (item) {
      return item.classList.contains('grid__item');
    });

    var visible = Math.max(1, parseInt(grid.dataset.visibleCount || '4', 10));
    var pageStarts = uniquePageStarts(items.length, visible);
    var pageIndex = 0;

    function isDesktop() {
      return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function cardStep() {
      var first = items[0];
      if (!first) return 292;
      return first.getBoundingClientRect().width / getCanvasScale(grid) + GAP;
    }

    function getCanvasScale(element) {
      var home = element.closest('.noahq-home');
      if (!home) return 1;

      var raw = getComputedStyle(home).getPropertyValue('--nq-canvas-scale');
      var value = parseFloat(raw);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    function render() {
      var desktop = isDesktop();
      var overflowing = desktop && items.length > visible;

      if (!overflowing) {
        pageIndex = 0;
        grid.classList.remove('is-overflowing');
        grid.style.removeProperty('--nq-product-slider-x');
        controls.hidden = true;
        setItemAccess(items, 0, visible, false);
        return;
      }

      pageIndex = Math.max(0, Math.min(pageIndex, pageStarts.length - 1));
      var start = pageStarts[pageIndex];
      var shift = start * cardStep();

      grid.classList.add('is-overflowing');
      grid.style.setProperty('--nq-product-slider-x', (-shift).toFixed(3) + 'px');

      controls.hidden = false;
      prev.disabled = pageIndex === 0;
      next.disabled = pageIndex === pageStarts.length - 1;

      setItemAccess(items, start, visible, true);
    }

    prev.addEventListener('click', function () {
      if (pageIndex <= 0) return;
      pageIndex -= 1;
      render();
    });

    next.addEventListener('click', function () {
      if (pageIndex >= pageStarts.length - 1) return;
      pageIndex += 1;
      render();
    });

    grid.dataset.noahqSliderReady = 'true';
    grid._noahqSliderRender = render;
    render();
  }

  function setupAll() {
    document.querySelectorAll('[data-noahq-product-slider]').forEach(setupSlider);
  }

  function renderAll() {
    document.querySelectorAll('[data-noahq-product-slider]').forEach(function (grid) {
      if (typeof grid._noahqSliderRender === 'function') {
        grid._noahqSliderRender();
      }
    });
  }

  function scheduleRender() {
    if (rafId) return;

    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      renderAll();
    });
  }

  function start() {
    setupAll();

    window.addEventListener('resize', scheduleRender, { passive: true });
    window.addEventListener('orientationchange', scheduleRender, { passive: true });

    var media = window.matchMedia(DESKTOP_QUERY);
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', scheduleRender);
    } else if (typeof media.addListener === 'function') {
      media.addListener(scheduleRender);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
